import * as THREE from 'three'

/**
 * Keep the opening gradient dome in camera space. The title camera orbits the
 * world, so a world-anchored dome makes its horizon drift across the screen.
 */
export function anchorSkyboxToCamera(skybox: THREE.Object3D, camera: THREE.Camera): void {
  skybox.position.copy(camera.position)
  skybox.quaternion.copy(camera.quaternion)
  skybox.frustumCulled = false
}
